import { ImpiantoDto, IAggiornaDateControlloData, AggiornaDateControlloData, ApparecchioCategory } from "../generated";
import ExpirationsActions from "../expirations/ExpirationsActions";
import { Dictionary } from "../common/AbstractStores";
export default class ImpiantiHelper {

    static async evadiScadenze(impianti: ImpiantoDto[], data: IAggiornaDateControlloData, categories: Dictionary<ApparecchioCategory>) {
        await ExpirationsActions.evadiScadenzeMassivo(impianti.map(x => ({ IdImpianto: x.idImpianto, IdCliente: x.idCliente })), new AggiornaDateControlloData(data), categories);
    }

    static async evadiScadenze2(input: { IdImpianto: number, IdCliente: number }[], data: IAggiornaDateControlloData, categories: Dictionary<ApparecchioCategory>) {
        await ExpirationsActions.evadiScadenzeMassivo(input, new AggiornaDateControlloData(data), categories);
    }

}